import * as React from 'react';

import ShipAddressModel from 'src/model/shipAddress.model';

import './AccountRequestAlert.scss';

interface IAccountRequestAlertProps {
  addressRequest: {
    address: ShipAddressModel;
    succed: boolean;
    failed: boolean;
  };
  onClearAlert(): void;
  t?: any;
}

class AccountRequestAlert extends React.Component<
  IAccountRequestAlertProps,
  any
> {
  public render() {
    const { t } = this.props;
    return (
      <div className="rp-account-request-alert--sent">
        <div className="rp-account-request-alert--sent-info">
          {this.props.addressRequest.succed ? (
            <span className="rpds-check-circle rp-account-request-alert--sent-icon-success" />
          ) : (
            <span className="rpds-error rp-account-request-alert--sent-icon-failure" />
          )}
          <section>
            <div className="rp-account-request-alert--sent-title">
              {this.props.addressRequest.succed
                ? `${t('accountShippingAddress.requestSentSuccessHeading')}`
                : `${t('accountShippingAddress.requestNotSentTxt')}`}
            </div>
            <div className="rp-account-request-alert--sent-text">
              {this.props.addressRequest.succed
                ? `${t('accountShippingAddress.requestSentSuccessTxt')}`
                : `${t('accountShippingAddress.requestProblem')}`}
            </div>
          </section>
        </div>
        <div className="rp-account-request-alert--sent-divider" />
        <button
          className="primary-button rp-account-request-alert--sent-button"
          onClick={e => this.props.onClearAlert()}
        >
          {this.props.addressRequest.succed
            ? `${t('common.continueActionTxt')}`
            : `${t('common.tryAgainActionTxt')}`}
        </button>
      </div>
    );
  }
}

export default AccountRequestAlert;
